import axios from '../../axiosInstances/axiosInstance';

export const deleteUserFave = (faveId) => {
  return axios.delete(`/users/favoriteOrders/${faveId}`);
};
